import type { LinkedArticle } from '@/features/articleContent';
import type { Article } from '@/pages/article/models/Article';

export const articles = [
  {
    id: 2060,
    slug: 'slug_2060',
    content: [
      {
        type: 'heading',
        attrs: {
          level: 2,
          id: 'headerh21',
        },
        style: 'atx',
        children: [
          {
            type: 'text',
            raw: 'Чем примечательна природа Китая',
          },
        ],
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: 'Поднебесная поражает невероятным количеством разных ландшафтов: в ней есть высокие горы с глубокими ущельями, бескрайние степи, живописные речные долины, таёжные и тропические леса.',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: 'Территория КНР площадью более 9 миллионов км² расположена в пределах трёх климатических поясов: умеренного, субтропического и тропического. Если на северо‑востоке страны зимой бывают морозы до −40°C, то в субтропиках температура не опускается зимой ниже от 0°C, а летом воздух прогревается до +30°C.',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'images',
        attrs: {
          caption: [
            {
              type: 'paragraph',
              children: [
                {
                  type: 'text',
                  raw: 'Китайское тюльпанное дерево • Гинкго двулопастное • Фото: Shutterstock',
                },
              ],
            },
          ],
          images: [
            'https://cdn.tripster.ru/photos/30b4c87f-7077-4f8c-837b-224742b24640.jpg',
            'https://cdn.tripster.ru/photos/9059ec58-574d-4fb3-985a-94ce06e8abb7.jpg',
          ],
        },
      },
      {
        type: 'blank_line',
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: 'Растительный мир Китая — один из самых богатых в мире. В этой азиатской стране растёт более 30 тысяч видов растений, в том числе 192 реликтовых вида — например, китайское тюльпанное дерево, фуцзяньский кипарис и древнее гинкго двулопастное. 2000 видов китайской флоры употребляют в пищу, а 3000 — используют в медицине.',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: 'Не менее разнообразен животный мир: в Поднебесной обитают порядка 500 видов млекопитающих и 1200 видов птиц. В северных регионах страны водятся волки, кабаны и еноты, в горах — тибетские медведи, рыси и снежные барсы, в степях — суслики, джейраны и тушканчики, а на юге — леопарды, большие панды, аллигаторы и озёрные дельфины.',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'images',
        attrs: {
          caption: [
            {
              type: 'paragraph',
              children: [
                {
                  type: 'text',
                  raw: 'Тибетский медведь • Снежный барс • Большая панда • Фото: Shutterstock',
                },
              ],
            },
          ],
          images: [
            'https://cdn.tripster.ru/photos/3f271e38-857b-4e55-ad96-ef64703100bb.jpg',
            'https://cdn.tripster.ru/photos/41ed4365-b535-475c-8bb2-76f5b18fff12.jpg',
            'https://cdn.tripster.ru/photos/9f17a92a-4361-40bd-9832-71062fc1cf0d.jpg',
          ],
        },
      },
      {
        type: 'blank_line',
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: 'Китай также богат водными ресурсами. В Поднебесной более 45 тысяч рек, в том числе две крупнейшие в мире — Янцзы и Хуанхэ. И конечно же, Китай славится ',
          },
          {
            type: 'link',
            children: [
              {
                type: 'text',
                raw: 'горами',
              },
            ],
            attrs: {
              url: 'https://experience.tripster.ru/tours/china/tags/v-gory',
            },
          },
          {
            type: 'text',
            raw: ', которые занимают почти 67% его территории. На юго‑западе КНР находится Тибетское нагорье Гималайских гор, где расположена высочайшая вершина Земли — Джомолунгма, или Эверест. Помимо этого, в стране есть множество горных систем, которые влекут любителей экотуризма, ',
          },
          {
            type: 'link',
            children: [
              {
                type: 'text',
                raw: 'треккинга',
              },
            ],
            attrs: {
              url: 'https://experience.tripster.ru/tours/china/tags/trekking',
            },
          },
          {
            type: 'text',
            raw: ' или альпинизма.',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'vue',
        attrs: {
          component: 'experiences',
          ids: '50982',
          type: 'tour',
        },
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: '',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'heading',
        attrs: {
          level: 2,
          id: 'headerh22',
        },
        style: 'atx',
        children: [
          {
            type: 'text',
            raw: 'Природные до­сто­при­ме­ча­тель­но­сти Китая',
          },
        ],
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: 'Красивых мест в ',
          },
          {
            type: 'link',
            children: [
              {
                type: 'text',
                raw: 'Поднебесной',
              },
            ],
            attrs: {
              url: 'https://experience.tripster.ru/tours/china/tags/perezagruzka',
            },
          },
          {
            type: 'text',
            raw: ' много, и наверняка увидеть захочется многие из них. Но есть среди них локации, которые непременно стоит изучить во время путешествия по стране. Ниже — список природных объектов, при виде которых сердце замрёт от восторга.',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'heading',
        attrs: {
          level: 3,
          id: 'headerh33',
        },
        style: 'atx',
        children: [
          {
            type: 'text',
            raw: 'Красивые места Китая на карте',
          },
        ],
      },
      {
        type: 'block_html',
        raw: '<p><iframe src="https://www.google.com/maps/d/u/3/embed?mid=1WHj-5jx3aWndOR1l6iCliDW8OlWNhwg&ehbc=2E312F&noprof=1" width="100%" height="480"></iframe></p>\n',
      },
      {
        type: 'blank_line',
      },
      {
        type: 'heading',
        attrs: {
          level: 3,
          id: 'headerh34',
        },
        style: 'atx',
        children: [
          {
            type: 'text',
            raw: 'Долина Хуанлун',
          },
        ],
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: 'Эта природная до­сто­при­ме­ча­тель­но­сть Китая поразит яркими красками и необычным рельефом. На территории национального парка «Хуанлун» на северо‑западе провинции Сычуань расположены более 3 тысяч природных бассейнов, наполненных водой разного цвета, которую она приобретает из‑за особых бактерий и водорослей.',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: 'При этом чаши бассейнов не разбросаны по территории, а образуют огромный каскад длиной почти 3,5 километра. Вода перетекает из одного пруда в другой, а их края сверкают как золотые (на самом деле они из известняка). Резервуары в этом месте формировались в течение столетий из кальцита, который содержался в ледниковой воде, стекавшей с гор. Из‑за перепада температуры соли кальция кристаллизовались и образовали природные бассейны разного размера. Если посмотреть на сеть водоёмов с горных вершин, то они кажутся чешуёй дракона. Кстати, название долины Хуанлун на китайском означает «жёлтый дракон».',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'cap_image',
        attrs: {
          url: 'https://cdn.tripster.ru/photos/9984e5ea-4eb0-4f46-bb45-f0d7863d5dcf.jpg',
          caption: [
            {
              type: 'paragraph',
              children: [
                {
                  type: 'text',
                  raw: 'Фото: Shutterstock',
                },
              ],
            },
          ],
          alt: 'Природа Китая',
        },
      },
      {
        type: 'blank_line',
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: 'Впрочем, в живописном заповеднике немало интересного и помимо разноцветных бассейнов. Долину окружают семь ',
          },
          {
            type: 'link',
            children: [
              {
                type: 'text',
                raw: 'горных вершин',
              },
            ],
            attrs: {
              url: 'https://experience.tripster.ru/tours/china/tags/v-gory',
            },
          },
          {
            type: 'text',
            raw: ' высотой порядка 5 тысяч метров, большую часть года покрытых снежными шапками. В заповеднике «Хуанлун» растут первозданные густые леса, где обитают редкие животные — например, гигантская панда и золотистая курносая обезьяна.',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: 'Для посетителей в парке проложены деревянные настилы с беседками. Есть также мостики, с которых можно умыться из цветного пруда и рассмотреть поближе необычную воду и края бассейнов.',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'block_html',
        raw: '<p style="background: url(https://cdn.tripster.ru/photos/01792ad4-2320-48cc-b1fa-779d3ce21d88.png) no-repeat 16px 21px #f1f1f1;background-size: 26px;"><span style="padding: 20px 25px 20px 56px;display: block;">Погулять по заповеднику и увидеть его флору и фауну получится только с апреля по ноябрь — в остальное время он закрыт.</span></p>\n',
      },
      {
        type: 'blank_line',
      },
      {
        type: 'images',
        attrs: {
          caption: [
            {
              type: 'paragraph',
              children: [
                {
                  type: 'text',
                  raw: 'Фото: Shutterstock',
                },
              ],
            },
          ],
          images: [
            'https://cdn.tripster.ru/photos/315c129a-b7be-4741-93bc-75941528de22.jpg',
            'https://cdn.tripster.ru/photos/0c500e2e-e93f-43ff-862c-40faf7bd505d.jpg',
            'https://cdn.tripster.ru/photos/7cd52b60-6ca5-4d44-b0ad-3732becc66a3.jpg',
          ],
        },
      },
      {
        type: 'blank_line',
      },
      {
        type: 'vue',
        attrs: {
          component: 'experiences',
          ids: '93387',
          type: 'tour',
        },
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: '',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'heading',
        attrs: {
          level: 3,
          id: 'headerh35',
        },
        style: 'atx',
        children: [
          {
            type: 'text',
            raw: 'Цветные горы Данься',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: 'Они находятся на северо‑западе Поднебесной в провинции Ганьсу. Национальный геологический парк «Чжанъе Данься» занимает площадь 510 км², и вся эта территория покрыта горами необычных форм и цветов. Скалистые холмы окрашены в красные, жёлтые, синие, зелёные, белые и серые оттенки, которые чередуются узкими полосками. Кажется, что по горам прошлись огромной кистью с разными красками. На самом деле такой фантастический ландшафт создала природа.',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: 'Около 80 миллионов лет назад здесь были реки и озёра, но после их высыхания на месте водоёмов остались отложения минералов. В результате тектонических сдвигов образовались возвышенности, которые миллионы лет подвергались воздействию ветра и воды. Так появились разноцветные скалы причудливых форм. А окрасились они благодаря процессам окисления. Красный цвет появился из‑за окисления пород, содержащих железо, зелёный — меди, а розовый — марганца.',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'images',
        attrs: {
          caption: [
            {
              type: 'paragraph',
              children: [
                {
                  type: 'text',
                  raw: 'Фото: Shutterstock',
                },
              ],
            },
          ],
          images: [
            'https://cdn.tripster.ru/photos/27e878cd-e0c8-4331-8121-22fc8d798323.jpg',
            'https://cdn.tripster.ru/photos/dde82a14-ca87-4947-97a4-f7a418cc80a5.jpg',
            'https://cdn.tripster.ru/photos/78e84801-5a30-4446-95f1-df7334bf1a32.jpg',
          ],
        },
      },
      {
        type: 'blank_line',
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: 'Оценить великолепные природные краски лучше всего получится на восходе и закате. В это время солнечные лучи по‑особенному окрашивают ',
          },
          {
            type: 'link',
            children: [
              {
                type: 'text',
                raw: 'горы',
              },
            ],
            attrs: {
              url: 'https://experience.tripster.ru/tours/china/tags/v-gory',
            },
          },
          {
            type: 'text',
            raw: ', и их цвета кажутся наиболее яркими. На территории геопарка проложены дороги и деревянные настилы, а также есть четыре смотровые площадки, куда можно подняться по лестнице, чтобы полюбоваться неземным пейзажем. Расстояние между ними — около восьми километров, преодолеть его можно пешком или на машине.',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'heading',
        attrs: {
          level: 3,
          id: 'headerh36',
        },
        style: 'atx',
        children: [
          {
            type: 'text',
            raw: 'Водопады Дэтянь',
          },
        ],
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: 'Грандиозный природный объект на границе Китая и Вьетнама. В переводе с китайского означает «водопад благородных небес». Дэтянь занимает четвёртое место в мире среди самых больших пограничных водопадов и первое — в Юго‑Восточной Азии.',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: 'Водопад образует река Гуйчунь, которая течёт среди карстовых холмов, а затем разделяется на множество рукавов. Ширина трёхуровневого водостока — порядка 200 метров, а общая высота всех ярусов — 60 метров. На первом этаже вода ниспадает почти вертикально в глубокую чашу, оттуда течёт по плавному откосу, а на нижнем ярусе снова с мощью падает вниз почти сплошной стеной. Особую силу потоки набирают летом в сезон дождей — в это время водопад срывается со скалы с оглушительным грохотом.',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'images',
        attrs: {
          caption: [
            {
              type: 'paragraph',
              children: [
                {
                  type: 'text',
                  raw: 'Фото: Shutterstock',
                },
              ],
            },
          ],
          images: [
            'https://cdn.tripster.ru/photos/69b9e7e4-a3d9-4137-b2c9-9fc5fc8e1d55.jpg',
            'https://cdn.tripster.ru/photos/82b362e7-db3d-4065-a517-0f4b08a5f48e.jpg',
            'https://cdn.tripster.ru/photos/36e5588b-4073-44de-af00-c17fd70fb96d.jpg',
          ],
        },
      },
      {
        type: 'blank_line',
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: 'Дэтянь окружает густой лес, ',
          },
          {
            type: 'link',
            children: [
              {
                type: 'text',
                raw: 'рисовые плантации',
              },
            ],
            attrs: {
              url: 'https://experience.tripster.ru/tours/china/tags/risovye-terrasy',
            },
          },
          {
            type: 'text',
            raw: ' и небольшие карстовые холмы. Полюбоваться каскадом вблизи можно с бамбуковых плотов, которые отправляются по озеру в низовье Дэтянь. По верху водопада проходит дорога, которая приводит к китайско-вьетнамской границе. Там установлен каменный столб, который как раз отмечает границу между странами. В 30 километрах от водопада расположен живописный каньон Тунлин с хрустальными водопадами и реками и девственным лесом, где водятся редкие животные и растения.',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'heading',
        attrs: {
          level: 3,
          id: 'headerh37',
        },
        style: 'atx',
        children: [
          {
            type: 'text',
            raw: 'Хуаншань',
          },
        ],
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: 'Небольшой национальный парк в восточной провинции Аньхой, где расположен горный массив Хуаншань. Он включает порядка 70 вершин, самыми известными среди них считаются три: пик Лотоса, пик Небесная Столица, Блестящий пик.',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: 'Первый — самый высокий (1873 метров), остальные два уступают ему порядка 30–60 метров. Подняться на них можно на фуникулёре или по ',
          },
          {
            type: 'link',
            children: [
              {
                type: 'text',
                raw: 'горным тропам',
              },
            ],
            attrs: {
              url: 'https://experience.tripster.ru/tours/china/tags/trekking',
            },
          },
          {
            type: 'text',
            raw: ', это займёт 3–4 часа.',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: 'Особенностью гор Хуаншань считают огромное количество вековых сосен необычных форм. Деревья растут на склонах с высоты 800 метров и до самых вершин, причём почти все сосны отличаются: одни выглядывают из‑за скал, словно любопытные дети, другие склонились в глубоком поклоне, а третьи раскинули ветви, как будто замерли в вечном сне. У многих сосен даже появились поэтичные имена — например, «Шахматная доска», «Спящий дракон» или «Сосна, встречающая гостей». Последнюю прозвали так потому, что её ветви тянутся в одну сторону, словно приветствуют каждого, кто проходит мимо.',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'vue',
        attrs: {
          component: 'link-card',
          id: '1784',
          type: 'article',
        },
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: '',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'images',
        attrs: {
          caption: [
            {
              type: 'paragraph',
              children: [
                {
                  type: 'text',
                  raw: 'Пик Лотоса и пик Небесная Столица • Сосна • Чайные плантации Хуаншань • Фото: Shutterstock',
                },
              ],
            },
          ],
          images: [
            'https://cdn.tripster.ru/photos/729c4829-c11a-4911-b427-b35edc76f950.jpg',
            'https://cdn.tripster.ru/photos/4f8b52df-847b-4639-9f3e-6b48ab82ad5c.jpg',
            'https://cdn.tripster.ru/photos/5b67cd45-6f12-4ed1-8a1a-b0baf125d3bf.jpg',
          ],
        },
      },
      {
        type: 'blank_line',
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: 'Кроме живописных пейзажей, Хуаншань славятся ',
          },
          {
            type: 'link',
            children: [
              {
                type: 'text',
                raw: 'чайными плантациями',
              },
            ],
            attrs: {
              url: 'https://experience.tripster.ru/tours/china/tags/tradicionnaya-chajnaya-ceremoniya',
            },
          },
          {
            type: 'text',
            raw: '. В горных долинах с X века выращивают сорт хуаншань маофэн, один из лучших в Китае. Застать сбор урожая на плантациях на высоте 700–800 метров получится в начале апреля. В остальное время можно заглянуть в древние деревушки у подножия горы или посетить горячие термальные источники. В Хуаншане они бьют уже более тысячи лет, вода с углекислым газом температурой +42°С помогает лечить болезни пищеварительной и нервной систем.',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'vue',
        attrs: {
          component: 'experiences',
          ids: '59112',
          type: 'tour',
        },
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: '',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'heading',
        attrs: {
          level: 3,
          id: 'headerh38',
        },
        style: 'atx',
        children: [
          {
            type: 'text',
            raw: 'Красный пляж Паньцзинь',
          },
        ],
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: 'Одно из самых ярких ',
          },
          {
            type: 'link',
            children: [
              {
                type: 'text',
                raw: 'природных мест Китая',
              },
            ],
            attrs: {
              url: 'https://experience.tripster.ru/tours/china/tags/priroda',
            },
          },
          {
            type: 'text',
            raw: ', причём в буквальном смысле. Расположено в восточной провинции Ляонин. Красным пляжем называют часть территории в устье реки Ляохэ, где простираются крупнейшие в мире водно‑болотные угодья. А необычный цвет этому месту придаёт растение из семейства амарантовых — сведа, которое способно расти на просоленной земле. Ковёр из травы раскинут широкой полосой на сотни метров. Большую часть года сведа зелёного цвета, а вот с сентября по ноябрь приобретает насыщенный пурпурный цвет — в это время пейзаж кажется совершенно неземным. Самым впечатляющим он бывает на закате, когда алые луга становятся тёмно‑багряными.',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: 'Полюбоваться на яркие поля можно с деревянных настилов и смотровых площадок. Сходить с них опасно: можно промочить ноги и увязнуть в глинистой почве. Кроме того, территория, где находится Красный пляж, — часть заповедника «Шуантай‑Хэкоу», находиться там можно только в определённых местах.',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'images',
        attrs: {
          caption: [
            {
              type: 'paragraph',
              children: [
                {
                  type: 'text',
                  raw: 'Фото: Shutterstock',
                },
              ],
            },
          ],
          images: [
            'https://cdn.tripster.ru/photos/4cfabf43-194d-4e2a-8885-a338f6379776.jpg',
            'https://cdn.tripster.ru/photos/c6922fca-e7a0-404f-9825-3d2ee24e5cb0.jpg',
            'https://cdn.tripster.ru/photos/8780fb5b-c2ea-48f3-a49d-9968827a8628.jpg',
          ],
        },
      },
      {
        type: 'blank_line',
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: 'Помимо необычного травяного покрова, посетители резервата наблюдают за тысячами пернатых: здесь проходит линия миграции порядка 250 видов птиц, которые летят из Европы и Азии в Австралию. Если повезёт, весной среди пролетающих колоний можно увидеть особо редкие образцы, которые находятся на грани вымирания — например, японских журавлей.',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'heading',
        attrs: {
          level: 3,
          id: 'headerh39',
        },
        style: 'atx',
        children: [
          {
            type: 'text',
            raw: 'Национальный парк «Цзючжайгоу»',
          },
        ],
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: 'Раскинулся на склонах горного хребта Миньшань и включает в себя три живописные долины. Название нацпарка переводится как «долина девяти деревень» — именно столько поселений находилось там в древности. Сейчас осталось только семь деревень, в которых живут около тысячи человек.',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'images',
        attrs: {
          caption: [
            {
              type: 'paragraph',
              children: [
                {
                  type: 'text',
                  raw: 'Озёра Национального парка: Тигровое • Тростниковое • Лебединое • Фото: Shutterstock',
                },
              ],
            },
          ],
          images: [
            'https://cdn.tripster.ru/photos/bd627076-460e-4932-b47a-2375eb41ae3b.jpg',
            'https://cdn.tripster.ru/photos/8f96e801-77f9-4a15-bb99-e7730504cc2e.jpg',
            'https://cdn.tripster.ru/photos/47defea2-fc34-4cb2-a188-773b19043f46.jpg',
          ],
        },
      },
      {
        type: 'blank_line',
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: 'На территории более 600 км² расположены великолепные и разнообразные ландшафты — можно увидеть первозданные леса, горные вершины, множество озёр и водопадов. Но больше всего «Цзючжайгоу» славится чистыми бирюзовыми озёрами разного размера. Всего на территории 114 водоёмов. Местная легенда гласит, что озёра — осколки зеркала. Его, по преданию, своей возлюбленной Воносэмо подарил бог Дагэ. Девушка нечаянно разбила зеркало, и рассыпавшиеся осколки превратились в чудесные водоёмы. Вода в них разных оттенков: голубая, тёмно‑серая, фиолетовая, коричневая. Палитра зависит от нескольких факторов: местной флоры, отражения света и содержание карбоната кальция в воде.',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: 'Удивительно, но почти у каждого водоёма есть свои фишки. Например, Тигровое озеро назвали так из‑за деревьев, которые отражаются в зеркальной глади воды, а их стволы напоминают полоски на шкуре тигра. На Тростниковом озере осенью и зимой берега становятся золотисто-жёлтыми — в такой цвет окрашиваются заросли тростника, когда растение достигает зрелости. Лебединое озеро назвали так из‑за стай уток и лебедей, которые там обитают.',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'vue',
        attrs: {
          component: 'link-card',
          id: '1715',
          type: 'article',
        },
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: '',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'images',
        attrs: {
          caption: [
            {
              type: 'paragraph',
              children: [
                {
                  type: 'text',
                  raw: 'Нуорилан • Водопад Жемчужная Отмель • Жемчужная Отмель зимой • Фото: Shutterstock',
                },
              ],
            },
          ],
          images: [
            'https://cdn.tripster.ru/photos/2236f7c9-e741-465e-a624-6258c42b3f4f.jpg',
            'https://cdn.tripster.ru/photos/c63dc516-2d55-478a-9d1a-708a73ed561c.jpg',
            'https://cdn.tripster.ru/photos/c0e9fc35-1ca8-4b5f-b491-def801820e1d.jpg',
          ],
        },
      },
      {
        type: 'blank_line',
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: 'Ещё в нацпарке можно увидеть один из самых широких водопадов в стране — Нуорилан. Его высота около 20 метров, а ширина — почти 300. А вот водопад Жемчужная Отмель удивит не размерами, а своей переменчивостью. После сильных дождей он мощным потоком срывается со скалы, летом стекает тонким ручейком, а зимой замерзает и превращается в хрустальные столбы.',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'vue',
        attrs: {
          component: 'experiences',
          ids: '81449',
          type: 'tour',
        },
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: '',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'heading',
        attrs: {
          level: 3,
          id: 'headerh310',
        },
        style: 'atx',
        children: [
          {
            type: 'text',
            raw: 'Каменный лес Шилинь',
          },
        ],
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: 'Удивительный ',
          },
          {
            type: 'link',
            children: [
              {
                type: 'text',
                raw: 'памятник природы Китая',
              },
            ],
            attrs: {
              url: 'https://experience.tripster.ru/tours/china/tags/priroda',
            },
          },
          {
            type: 'text',
            raw: ', который действительно похож на лесную чащу из камня. В национальном парке «Шилинь», который занимает площадь 350 км², высятся тысячи карстовых скал самых невероятных форм. Их очертания напоминают не только разнообразные деревья, но и животных, птиц, людей и замки. Высота каменных образований — от двух до 30–40 метров.',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: 'Фантастический карстовый лес образовался миллионы лет назад. Но как именно — до сих пор неизвестно. По одной версии, около 270 миллионов скалы были морским дном, которое в результате тектонических сдвигов поднялось и пересохло. Под воздействием ветра и воды камни получили такую причудливую форму. Другая версия гласит, что это окаменелый древний лес. По местной легенде, лес Шилинь создали божества. Они разбили гору на тысячи осколков и построили из них лабиринт — там влюблённые боги могли уединиться от посторонних глаз.',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'images',
        attrs: {
          caption: [
            {
              type: 'paragraph',
              children: [
                {
                  type: 'text',
                  raw: 'Фото: Shutterstock',
                },
              ],
            },
          ],
          images: [
            'https://cdn.tripster.ru/photos/31bb21b7-c3c8-4c1a-b02c-dec2f21cbb1b.jpg',
            'https://cdn.tripster.ru/photos/a4a0084c-f232-4d6e-9ab9-df13e8042fd7.jpg',
            'https://cdn.tripster.ru/photos/29ac2e87-c1a1-4a24-b158-0a3314dcbaf7.jpg',
          ],
        },
      },
      {
        type: 'blank_line',
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: 'На территории нацпарка «Шилинь» можно полюбоваться каменными пейзажами. В Большом каменном лесу посетители рассматривают 40‑метровые стелы, которые стоят почти вплотную. А в Малом лесу гуляют среди невысоких каменных глыб, между которыми есть поляны и участки бамбукового леса. Также в заповеднике получится заглянуть в пещеру Чжиюн площадью порядка 3 км², внутри которой тоже высится каменный лес. Ещё в нацпарке расположен водопад Дадиэшуй — крупнейший в провинции Юньнань. Его ширина около 30 метров, а потоки воды ниспадают с высоты 88 метров.',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'heading',
        attrs: {
          level: 3,
          id: 'headerh311',
        },
        style: 'atx',
        children: [
          {
            type: 'text',
            raw: 'Заповедник панд в Чэнду',
          },
        ],
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: 'Миловидные чёрно‑белые животные — символ Поднебесной, а увидеть их можно в нескольких уголках Китая. Резерват неподалёку от города ',
          },
          {
            type: 'link',
            children: [
              {
                type: 'text',
                raw: 'Чэнду',
              },
            ],
            attrs: {
              url: 'https://experience.tripster.ru/experience/Chengdu/',
            },
          },
          {
            type: 'text',
            raw: '{:target="',
          },
          {
            type: 'text',
            raw: '_',
          },
          {
            type: 'text',
            raw: 'blank"} — один из заповедников, где разводят и изучают панд. Там в естественных условиях обитают порядка 100 животных. За ними присматривают специалисты: кормят и лечат. При этом у каждого мишки есть имя и собственный смотритель.',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: 'Для посетителей заповедник открыт во все дни, кроме понедельника. Самое интересное в питомнике — ',
          },
          {
            type: 'link',
            children: [
              {
                type: 'text',
                raw: 'наблюдать за кормлением панд',
              },
            ],
            attrs: {
              url: 'https://experience.tripster.ru/tours/china/tags/pandy',
            },
          },
          {
            type: 'text',
            raw: '. В то время, когда они лакомятся бамбуком, получится хорошо рассмотреть очаровашек. В остальные моменты они могут прятаться в зарослях. Особенно проблематично разглядеть панд в жару: от неё мишки укрываются в своих вольерах.',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'images',
        attrs: {
          caption: [
            {
              type: 'paragraph',
              children: [
                {
                  type: 'text',
                  raw: 'Фото: Shutterstock',
                },
              ],
            },
          ],
          images: [
            'https://cdn.tripster.ru/photos/6b6ec0fc-5a50-4edd-9445-36fe13e2a62b.jpg',
            'https://cdn.tripster.ru/photos/4e243850-3907-4c19-9866-41c37a01ea58.jpg',
            'https://cdn.tripster.ru/photos/b8a99133-42e8-44fb-a155-02a1b31155a7.jpg',
          ],
        },
      },
      {
        type: 'blank_line',
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: 'Также на территории заповедника живут аисты, журавли, павлины и красные панды, которые больше похожи на крупных кошек. Можно зайти в питомник для маленьких панд, где они находятся после рождения. Ещё одна местная до­сто­при­ме­ча­тель­но­сть — Музей панд. В коллекции есть тысячи экспонатов, посвящённых редким животным и другим вымирающим видам.',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'vue',
        attrs: {
          component: 'experiences',
          ids: '84356',
        },
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: '',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'heading',
        attrs: {
          level: 3,
          id: 'headerh312',
        },
        style: 'atx',
        children: [
          {
            type: 'text',
            raw: 'Озеро Цинхай',
          },
        ],
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: 'Крупнейший в Центральной Азии высокогорный водоём с солёной водой. Озеро, которое ещё называют Кукунор (в переводе с монгольского «Голубое»), расположено в провинции Цинхай на высоте 3200 метров. В водоём впадает две реки, из‑за чего уровень воды в Цинхай постоянно колеблется. Площадь озера — 4200 км², оно протянулось на 105 километров, а ширина в разных местах колеблется от 60 до 65 километров.',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: 'Впрочем, озеро поражает даже не размерами, а невероятной красотой. Со всех сторон его окружают степи и вершины горной системы Наньшань, которые отражаются в зеркальной глади. В озере есть пять островков разного размера, которые привлекают бёрдвотчеров. На участках суши обитают десятки тысяч пернатых — особенно они облюбовали острова Хайсишань и Няодао. Всего на озере водится около 20 видов птиц, которые останавливаются в этом месте во время миграции из Азии в Европу и обратно.',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'images',
        attrs: {
          caption: [
            {
              type: 'paragraph',
              children: [
                {
                  type: 'text',
                  raw: 'Фото: Shutterstock',
                },
              ],
            },
          ],
          images: [
            'https://cdn.tripster.ru/photos/09ca7772-90d1-4aa5-a22f-f33cfe59dd76.jpg',
            'https://cdn.tripster.ru/photos/71f609ed-46dd-4e55-8d23-e90caf17d291.jpg',
          ],
        },
      },
      {
        type: 'blank_line',
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: 'Несмотря на отдалённость от больших городов (ближайший Синан — в 100 километрах), на побережье озера любят отдыхать путешественники. На Цхинхае можно отправиться на велопрогулку, прокатиться верхом на яке или прогуляться по берегу, чтобы насладиться пейзажами и уединением. По пути отдыхающие изучают местные до­сто­при­ме­ча­тель­но­сти. Одна из них — камень Ганчжур, священное место для жителей региона. По преданию, если пройти через узкую щель в нём, это очистит от грехов и подарит бессмертие.',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'heading',
        attrs: {
          level: 2,
          id: 'headerh213',
        },
        style: 'atx',
        children: [
          {
            type: 'text',
            raw: 'Заключение',
          },
        ],
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: 'Разнообразная природа может стать весомым поводом для насыщенного путешествия по Поднебесной. А составить удобный маршрут по природным объектам доверьте ',
          },
          {
            type: 'link',
            children: [
              {
                type: 'text',
                raw: 'местному проводнику',
              },
            ],
            attrs: {
              url: 'https://experience.tripster.ru/tours/china/',
            },
          },
          {
            type: 'text',
            raw: '{:target="',
          },
          {
            type: 'text',
            raw: '_',
          },
          {
            type: 'text',
            raw: 'blank"} — он точно знает, куда и когда поехать, чтобы увидеть впечатляющие памятники природы Китая. Актуальные предложения для бронирования туров доступны на ',
          },
          {
            type: 'link',
            children: [
              {
                type: 'text',
                raw: 'сайте Tripster',
              },
            ],
            attrs: {
              url: 'https://experience.tripster.ru/tours/china/',
            },
          },
          {
            type: 'text',
            raw: '{:target="',
          },
          {
            type: 'text',
            raw: '_',
          },
          {
            type: 'text',
            raw: 'blank"}.',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'vue',
        attrs: {
          component: 'experiences',
          ids: '79360,67833,76678',
          type: 'tour',
        },
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: '',
          },
        ],
      },
    ],
  },
  {
    id: 2061,
    slug: 'slug_2061',
    content: [
      {
        type: 'heading',
        attrs: {
          level: 2,
          id: 'headerh21',
        },
        style: 'atx',
        children: [
          {
            type: 'text',
            raw: 'О поездке',
          },
        ],
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: 'Вот уже несколько лет я путешествую по России в компании подруг, с которыми знакома со школы и университета. Чаще всего мы планируем новую поездку весной, а отправляемся в неё летом. В прошлом году, например, бороздили волны Ладожского озера на быстроходном катере и грелись на солнце, гуляя по острову Валаам в Карелии. А в этом решили не дожидаться тёплой погоды и запланировали двухдневное ',
          },
          {
            type: 'link',
            children: [
              {
                type: 'text',
                raw: 'путешествие в Псков',
              },
            ],
            attrs: {
              url: 'https://experience.tripster.ru/experience/Pskov/',
            },
          },
          {
            type: 'text',
            raw: '{:target="',
          },
          {
            type: 'text',
            raw: '_',
          },
          {
            type: 'text',
            raw: 'blank"} на март.',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'images',
        attrs: {
          caption: [
            {
              type: 'paragraph',
              children: [
                {
                  type: 'text',
                  raw: 'Фото с экскурсии «',
                },
                {
                  type: 'inline_html',
                  raw: "<a target='_blank' style='text-decoration: none' href='https://experience.tripster.ru/experience/43892/'>",
                },
                {
                  type: 'text',
                  raw: 'Древняя Русь без тоски: Изборск',
                },
                {
                  type: 'inline_html',
                  raw: '</a>',
                },
                {
                  type: 'text',
                  raw: '»',
                },
              ],
            },
          ],
          images: [
            'https://cdn.tripster.ru/photos/a4389d9c-9f85-4513-b4a5-144c943a3155.jpg',
            'https://cdn.tripster.ru/photos/db5b447b-71e5-4038-948c-1383e107ab70.jpg',
          ],
        },
      },
      {
        type: 'blank_line',
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: 'Ещё на подготовительном этапе возникла мысль, что одного дня вполне достаточно, чтобы изучить этот город, — впоследствии это предположение подтвердилось. Тогда встал вопрос — что посмотреть поблизости. Одна из подруг предложила Изборск, но поначалу он показался скучным: крепость, храмы и, в общем‑то, всё. Но мы всё же стали искать экскурсии и наткнулись на прогулку от местного жителя «Древняя Русь без тоски: Изборск» на Трипстере. Заголовок звучал как вызов, и мы решили — едем. Спойлер — никто из нас об этом ни разу не пожалел.',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'vue',
        attrs: {
          component: 'experiences',
          ids: '43892',
        },
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: '',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'heading',
        attrs: {
          level: 2,
          id: 'headerh22',
        },
        style: 'atx',
        children: [
          {
            type: 'text',
            raw: 'Где находится и как добраться',
          },
        ],
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: 'Изборск расположен в 30 километрах от Пскова. До него можно доехать за полтора часа на автобусе (номера маршрутов и актуальное расписание уточняйте на местном автовокзале), но гораздо быстрее и комфортнее — на такси.',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: 'Мы воспользовались агрегатором, и уже через несколько минут у подъезда нашего дома стояла старенькая, но резвая иномарка. Водитель нисколько не удивился, что ему предстоит ',
          },
          {
            type: 'link',
            children: [
              {
                type: 'text',
                raw: 'поездка из Пскова в Изборск',
              },
            ],
            attrs: {
              url: 'https://experience.tripster.ru/experience/Pskov/9982-izborsk/',
            },
          },
          {
            type: 'text',
            raw: '{:target="',
          },
          {
            type: 'text',
            raw: '_',
          },
          {
            type: 'text',
            raw: 'blank"}, из чего можно сделать вывод: это распространённый способ перемещения между городами. Спустя полчаса мы уже были на месте. Так как нас было четверо, поездка обошлась очень дёшево — по 250 рублей с человека.',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'heading',
        attrs: {
          level: 2,
          id: 'headerh23',
        },
        style: 'atx',
        children: [
          {
            type: 'text',
            raw: 'Немного истории',
          },
        ],
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: 'Обычно я заранее изучаю место, которое собираюсь посетить. С ',
          },
          {
            type: 'link',
            children: [
              {
                type: 'text',
                raw: 'Изборском',
              },
            ],
            attrs: {
              url: 'https://experience.tripster.ru/experience/Izborsk/',
            },
          },
          {
            type: 'text',
            raw: '{:target="',
          },
          {
            type: 'text',
            raw: '_',
          },
          {
            type: 'text',
            raw: 'blank"} всё было иначе, ведь мы до последнего сомневались, ехать в этот город или нет. Вся надежда была на нашего проводника Данилу. Поскольку экскурсия касалась древнерусского периода в истории Изборска, он подробно остановился только на этой эпохе.',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: 'Доподлинно известно немногое, объяснил Данила, так как достоверных данных о тех далёких временах мало. Так, из «Повести временных лет» мы знаем, что Изборск возник в 862 году, а артефакты, найденные археологами на территории города, указывают, что его основали славяне. Первопоселенцы занимались ремёслами и активно вели торговлю, о чём свидетельствуют обнаруженные в этих местах изделия из металла, дерева и даже кости, а также многочисленные монеты.',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'images',
        attrs: {
          caption: [
            {
              type: 'paragraph',
              children: [
                {
                  type: 'text',
                  raw: 'Изборская крепость. Фото автора',
                },
              ],
            },
          ],
          images: [
            'https://cdn.tripster.ru/photos/b983fd06-f03e-4733-a63e-20c16d721925.jpg',
            'https://cdn.tripster.ru/photos/33a04e14-5d0a-4b64-8c12-794b54c9e447.jpg',
          ],
        },
      },
      {
        type: 'blank_line',
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: 'Вероятно, изборяне так и вели бы тихую жизнь, если бы не расположение города: во времена Древней Руси он стоял на границе государства, поэтому то и дело становился главным участником вооружённых конфликтов с Западом. Сегодня о тех неспокойных временах напоминает Изборская крепость — удивительный памятник оборонного зодчества XIV века. Это визитная карточка города и то, ради чего в него едут тысячи путешественников из разных уголков России.',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'heading',
        attrs: {
          level: 2,
          id: 'headerh24',
        },
        style: 'atx',
        children: [
          {
            type: 'text',
            raw: 'Наш маршрут по городу',
          },
        ],
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: 'Все локации, о которых я расскажу далее, нам показал Данила во время экскурсии. Если их объединить, получится классический ',
          },
          {
            type: 'link',
            children: [
              {
                type: 'text',
                raw: 'маршрут по Изборску',
              },
            ],
            attrs: {
              url: 'https://experience.tripster.ru/experience/Pskov/9982-izborsk/',
            },
          },
          {
            type: 'text',
            raw: '{:target="',
          },
          {
            type: 'text',
            raw: '_',
          },
          {
            type: 'text',
            raw: 'blank"}, который позволяет осмотреть город за два или три часа.',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'heading',
        attrs: {
          level: 3,
          id: 'headerh35',
        },
        style: 'atx',
        children: [
          {
            type: 'text',
            raw: 'Печорская улица',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: 'Её также называют Музейной, что неслучайно. Здесь сосредоточены бывшие усадьбы местных купцов, в которых находятся экспозиции, посвящённые городу. Среди экспонатов, например, подлинные предметы с тысячелетней историей — бронзовые перстни, булавки, фибулы и височные кольца (украшения, которые вплетали в волосы у висков), выполненные местными ювелирами в эпоху Древней Руси. Все эти вещи пролежали в земле сотни лет и были обнаружены во время раскопок на территории Изборска.',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: 'Увы, об этом мы узнали лишь со слов гида: осмотреть экспозиции нам не удалось, так как мы приехали в город в девять утра и музеи ещё были закрыты. Пришлось ограничиться фотосессией на фоне исторических фасадов.',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'images',
        attrs: {
          caption: [
            {
              type: 'paragraph',
              children: [
                {
                  type: 'text',
                  raw: 'Печорская улица. Фото автора',
                },
              ],
            },
          ],
          images: [
            'https://cdn.tripster.ru/photos/1efe2718-8d74-41a1-9816-2edc2d19abb1.jpg',
            'https://cdn.tripster.ru/photos/a0cff511-47d4-4600-a844-5aa12a52b180.jpg',
            'https://cdn.tripster.ru/photos/9621e736-dab4-4fa0-b95c-698947110c33.jpg',
          ],
        },
      },
      {
        type: 'blank_line',
      },
      {
        type: 'heading',
        attrs: {
          level: 3,
          id: 'headerh36',
        },
        style: 'atx',
        children: [
          {
            type: 'text',
            raw: 'Изборская крепость',
          },
        ],
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: 'Изборчане построили её почти 700 лет назад для защиты русских земель от рыцарей Ливонского ордена. Её стены и башни выдержали не менее восьми осад и уцелели, что, впрочем, неудивительно. Средняя толщина стен — три‑четыре метра, а высота варьируется от 7,5 до 19 метров! И это без учёта внушительных размеров Жеравьей горы, на которой стоит твердыня.',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: 'Пока наш проводник рассказывал о других особенностях крепости, моё внимание привлекла каменная кладка в виде крестов между башнями Вышка и Рябиновка. Как оказалось, эти символы служили дополнительным оберегом, ведь именно с западной стороны изборчане ожидали первого удара от врага.',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: 'Слушая истории о главной до­сто­при­ме­ча­тель­но­сти города, мы не заметили, как наша группа пополнилась ещё одним участником — местным котом, который в одно мгновение завладел вниманием моих подруг. В его компании мы и двинулись дальше.',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'images',
        attrs: {
          caption: [
            {
              type: 'paragraph',
              children: [
                {
                  type: 'text',
                  raw: 'Башня Вышка • Кладка в виде креста • Местный кот • Фото автора',
                },
              ],
            },
          ],
          images: [
            'https://cdn.tripster.ru/photos/1511d272-b469-463e-ac91-14e1c7dae541.jpg',
            'https://cdn.tripster.ru/photos/3f3c607c-b1b3-49d4-9b62-1fca7aea182c.jpg',
            'https://cdn.tripster.ru/photos/4812a844-dd65-4e4a-b25c-8478aa9fbb03.jpg',
          ],
        },
      },
      {
        type: 'blank_line',
      },
      {
        type: 'vue',
        attrs: {
          component: 'experiences',
          ids: '24224',
        },
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: '',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'heading',
        attrs: {
          level: 3,
          id: 'headerh37',
        },
        style: 'atx',
        children: [
          {
            type: 'text',
            raw: 'Городищенское озеро',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: 'Подойдя к краю Жеравьей горы, мы устроились в тени неприступных стен и башен ',
          },
          {
            type: 'link',
            children: [
              {
                type: 'text',
                raw: 'Изборской крепости',
              },
            ],
            attrs: {
              url: 'https://experience.tripster.ru/experience/Izborsk/37848-izborskaya-krepost/',
            },
          },
          {
            type: 'text',
            raw: '{:target="',
          },
          {
            type: 'text',
            raw: '_',
          },
          {
            type: 'text',
            raw: 'blank"}, чтобы полюбоваться местным пейзажем. Перед нами открывалась потрясающая панорама голубого водоёма и окружающих его холмов, которые кое‑где уже зеленели под пригревающими лучами весеннего солнца.',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'link',
            children: [
              {
                type: 'text',
                raw: 'Городищенское озеро',
              },
            ],
            attrs: {
              url: 'https://experience.tripster.ru/experience/Izborsk/37847-gorodishenskoe-ozero/',
            },
          },
          {
            type: 'text',
            raw: '{:target="',
          },
          {
            type: 'text',
            raw: '_',
          },
          {
            type: 'text',
            raw: 'blank"} лежит на дне живописной долины, которую питают многочисленные реки и родники. Благодаря особому климату, его берега укрыты покрывалом из реликтовых растений. Так как мы были там в марте, нам удалось полюбоваться цветением первоцветов: подснежников, ландышей и медуницы.',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: 'Глядя на эту красоту, понимаешь, чем город привлекает художников и кинематографистов. Местные пейзажи можно увидеть на картинах Николая Рериха и в фильмах таких режиссёров, как Андрей Тарковский и Владимир Мотыль (например, «Андрей Рублёв» и «Звезда пленительного счастья»).',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'cap_image',
        attrs: {
          url: 'https://cdn.tripster.ru/photos/84e125ec-cec6-4e81-9784-3033e7e35981.jpg',
          caption: [
            {
              type: 'paragraph',
              children: [
                {
                  type: 'text',
                  raw: 'Фото с экскурсии «',
                },
                {
                  type: 'inline_html',
                  raw: "<a target='_blank' style='text-decoration: none' href='https://experience.tripster.ru/experience/43892/'>",
                },
                {
                  type: 'text',
                  raw: 'Древняя Русь без тоски: Изборск',
                },
                {
                  type: 'inline_html',
                  raw: '</a>',
                },
                {
                  type: 'text',
                  raw: '»',
                },
              ],
            },
          ],
          alt: 'Городищенское озеро',
        },
      },
      {
        type: 'blank_line',
      },
      {
        type: 'heading',
        attrs: {
          level: 3,
          id: 'headerh38',
        },
        style: 'atx',
        children: [
          {
            type: 'text',
            raw: 'Труворово городище',
          },
        ],
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: 'Именно здесь находился город до строительства крепости в XIV веке. Как выяснили учёные, его населяли кривичи — славянское племя, сформировавшееся в VII–VIII веках. А ',
          },
          {
            type: 'link',
            children: [
              {
                type: 'text',
                raw: 'Труворовым',
              },
            ],
            attrs: {
              url: 'https://experience.tripster.ru/experience/Izborsk/37852-truvorovo-gorodishe/',
            },
          },
          {
            type: 'text',
            raw: '{:target="',
          },
          {
            type: 'text',
            raw: '_',
          },
          {
            type: 'text',
            raw: 'blank"} город назывался в честь варяга Трувора — брата Рюрика и Синеуса, который, согласно легендам, пришёл княжить в Изборск в 862 году.',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: 'Слушая рассказы об этом месте, я живо представляла картины из далёкого прошлого: как жители города собирались на вече, где принимали решения, проводили обряды и гадали на будущее. Мне слышались удары плотницкого топора и грохот кузнечной наковальни и виделись дружинники, несущие дозор на стенах и башнях деревянного детинца.',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: 'Сегодня о жизни первых поселенцев уже ничто не напоминает, но, подойдя к краю мыса, где давным‑давно стояли их дома, невозможно отделаться от ощущения, что память о той эпохе ещё жива в каждом камне и дереве, которые виднеются вдали.',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'images',
        attrs: {
          caption: [
            {
              type: 'paragraph',
              children: [
                {
                  type: 'text',
                  raw: 'Труворово городище и котик. Фото автора',
                },
              ],
            },
          ],
          images: [
            'https://cdn.tripster.ru/photos/3a17c1e0-7c34-4513-9bd2-d5b9d892a2aa.jpg',
            'https://cdn.tripster.ru/photos/9af54e51-a528-4030-826b-184de14861ae.jpg',
          ],
        },
      },
      {
        type: 'blank_line',
      },
      {
        type: 'heading',
        attrs: {
          level: 3,
          id: 'headerh39',
        },
        style: 'atx',
        children: [
          {
            type: 'text',
            raw: 'Церковь Николая Чудотворца',
          },
        ],
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: 'Единственный ',
          },
          {
            type: 'link',
            children: [
              {
                type: 'text',
                raw: 'памятник архитектуры',
              },
            ],
            attrs: {
              url: 'https://experience.tripster.ru/experience/Izborsk/6989-istoriya-i-arhitektura/',
            },
          },
          {
            type: 'text',
            raw: '{:target="',
          },
          {
            type: 'text',
            raw: '_',
          },
          {
            type: 'text',
            raw: 'blank"} рядом с Труворовым городищем. Никольская церковь относится к более позднему периоду в истории города — XV–XVIII векам. Несмотря на это, она идеально вписывается в местный пейзаж и навевает мысли о былых временах, когда вера была важной частью жизни изборчан.',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: 'У церкви нет колокольни. В отличие от храмов в других регионах России, она увенчана звонницей в виде небольшой стены с проёмами для колоколов, характерной для культового зодчества Псковской области. Это выглядит очень непривычно, но придаёт зданию неповторимый вид.',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: 'Для нас Никольская церковь особенно памятна тем, что нам удалось позвонить в её колокола. Такая возможность выпадает не каждому путешественнику, ведь это православная святыня, а значит, любое действие нужно согласовывать с местным батюшкой. У Данилы такое разрешение было.',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: 'Словно в оцепенении, мы слушали, как колокольный звон превращался в эхо и разносился по притихшей долине. К реальности вернули громкие голоса школьников, подходящих к Никольской церкви, и мы поспешили к следующей точке маршрута.',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'images',
        attrs: {
          caption: [
            {
              type: 'paragraph',
              children: [
                {
                  type: 'text',
                  raw: 'Церковь Николая Чудотворца • Вид на храм с дороги • Фото автора',
                },
              ],
            },
          ],
          images: [
            'https://cdn.tripster.ru/photos/2e29ce2a-7f0d-4ac3-a520-19e028489bda.jpg',
            'https://cdn.tripster.ru/photos/dcda7ea8-6e8c-4f7e-8af5-270f29c4a927.jpg',
          ],
        },
      },
      {
        type: 'blank_line',
      },
      {
        type: 'vue',
        attrs: {
          component: 'experiences',
          ids: '42268',
          type: 'tour',
        },
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: '',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'heading',
        attrs: {
          level: 3,
          id: 'headerh310',
        },
        style: 'atx',
        children: [
          {
            type: 'text',
            raw: 'Труворов крест',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: 'С ним связано множество легенд. Согласно самой распространённой, он стоит на могиле варяжского князя Трувора, что правил в Изборске в 860‑е годы. Однако это не более чем миф. Как выяснили учёные, крест датируется XIV–XV веками. Скорее всего, его установили около городища гораздо позднее как напоминание о первых поселенцах.',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: 'Обойдя этот памятник по кругу, мы уже думали двигаться дальше, но наш проводник предложил задержаться и рассмотреть древние граффити, процарапанные на плите у основания ',
          },
          {
            type: 'link',
            children: [
              {
                type: 'text',
                raw: 'Труворова креста',
              },
            ],
            attrs: {
              url: 'https://experience.tripster.ru/experience/Izborsk/64453-truvorov-krest/',
            },
          },
          {
            type: 'text',
            raw: '{:target="',
          },
          {
            type: 'text',
            raw: '_',
          },
          {
            type: 'text',
            raw: 'blank"}. Под толстым слоем прошлогодней листвы скрывался символ в виде вписанных друг в друга квадратов, соединённых между собой чёрточками. Не исключено, что это поле для игры в «мельницу» — аналог шашек и шахмат эпохи Средневековья. Рядом есть и другие символы, но их смысл ещё предстоит раскрыть учёным.',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'images',
        attrs: {
          caption: [
            {
              type: 'paragraph',
              children: [
                {
                  type: 'text',
                  raw: 'Труворов крест • Древние граффити • Фото автора',
                },
              ],
            },
          ],
          images: [
            'https://cdn.tripster.ru/photos/524be0f5-1cd7-4d12-bb71-a6bd2b6ca772.jpg',
            'https://cdn.tripster.ru/photos/7fde6647-9292-4049-b31f-2c68050039a8.jpg',
          ],
        },
      },
      {
        type: 'blank_line',
      },
      {
        type: 'heading',
        attrs: {
          level: 3,
          id: 'headerh311',
        },
        style: 'atx',
        children: [
          {
            type: 'text',
            raw: 'Словенские ключи',
          },
        ],
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: 'После осмотра древнейшей части Изборска мы спустились в живописную долину и направились к ещё одному чуду природы — ',
          },
          {
            type: 'link',
            children: [
              {
                type: 'text',
                raw: 'Словенским ключам',
              },
            ],
            attrs: {
              url: 'https://experience.tripster.ru/experience/Izborsk/37851-slovenskie-klyuchi/',
            },
          },
          {
            type: 'text',
            raw: '{:target="',
          },
          {
            type: 'text',
            raw: '_',
          },
          {
            type: 'text',
            raw: 'blank"}. Это карстовые источники, которые вытекают из недр земли и питают Городищенское озеро.',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: 'Родниковую воду можно пить, но прежде к ней придётся пробираться по влажному мху и скользким камням. Это настоящее испытание, которое требует сноровки и терпения.',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: 'Сначала мы струсили: никто не хотел мокнуть, но Данила сказал, что ручьи разные по вкусу, а выбирать нужно тот, который «смотрит именно на тебя». Это пробудило в нас азарт, и мы по очереди испили родниковой воды, которая действительно оказалась разной в каждом источнике (или мы себя в этом убедили). Не остановило нас даже то, что стакан был всего один на четверых.',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: 'Остаток времени мы провели на пирсе, у которого плавали белые лебеди. Городищенское озеро — их дом. Стая птиц облюбовала этот водоём почти полвека назад и с тех пор не покидает его даже зимой.',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'images',
        attrs: {
          caption: [
            {
              type: 'paragraph',
              children: [
                {
                  type: 'text',
                  raw: 'Словенские ключи • Лебеди на Городищенском озере • Фото автора',
                },
              ],
            },
          ],
          images: [
            'https://cdn.tripster.ru/photos/1d172c75-4395-4f0d-9c1f-b2e8eb05ea42.jpg',
            'https://cdn.tripster.ru/photos/96c5e9e1-0f54-4184-a863-5da0473d584f.jpg',
          ],
        },
      },
      {
        type: 'blank_line',
      },
      {
        type: 'heading',
        attrs: {
          level: 3,
          id: 'headerh312',
        },
        style: 'atx',
        children: [
          {
            type: 'text',
            raw: 'Никольский собор',
          },
        ],
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: 'Древнейший храм города расположен на территории ',
          },
          {
            type: 'link',
            children: [
              {
                type: 'text',
                raw: 'Изборской крепости',
              },
            ],
            attrs: {
              url: 'https://experience.tripster.ru/experience/Izborsk/37848-izborskaya-krepost/',
            },
          },
          {
            type: 'text',
            raw: '{:target="',
          },
          {
            type: 'text',
            raw: '_',
          },
          {
            type: 'text',
            raw: 'blank"}, поэтому нам предстояло вновь подняться на Жеравью гору. Мы шли по извилистой тропинке, которая вела всё выше и выше, и меня не покидало чувство, что я нахожусь в русской сказке. Отовсюду пахло пирожками, которыми торгуют местные бабушки, за резными палисадами кричали петухи, а с веток деревьев за нами наблюдали мартовские коты.',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: 'В конце концов мы подошли к крепости и проникли в неё через тайный лаз — глубокую нишу в стене. В мирное время её закладывали камнями, но в случае осады разбирали, чтобы отправить гонца за помощью в Псков. В наши дни это своеобразный памятник изобретательности изборчан.',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: 'Внутри крепости наш путь лежал на смотровую площадку на башне Луковка, откуда открывается лучший вид Никольский собор. Там перед нами предстало будто вросшее в землю здание из камня, ставшее свидетелем 700‑летней истории города.',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: 'Никольский собор впервые упоминается в летописи XIV века. С тех пор молитва в нём ни разу не прерывалась, даже во время революций и войн прошлого столетия. Несмотря на строгие формы, храм вызывает ощущение умиротворения и покоя. С этим чувством мы покинули ',
          },
          {
            type: 'link',
            children: [
              {
                type: 'text',
                raw: 'Изборскую крепость',
              },
            ],
            attrs: {
              url: 'https://experience.tripster.ru/experience/Izborsk/37848-izborskaya-krepost/',
            },
          },
          {
            type: 'text',
            raw: '{:target="',
          },
          {
            type: 'text',
            raw: '_',
          },
          {
            type: 'text',
            raw: 'blank"}, попрощались с Данилой и отправились на поиски местных специалитетов для пикника.',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'images',
        attrs: {
          caption: [
            {
              type: 'paragraph',
              children: [
                {
                  type: 'text',
                  raw: 'Тайный лаз в крепость • «Гнездо» мартовского кота • Никольский собор • Фото автора',
                },
              ],
            },
          ],
          images: [
            'https://cdn.tripster.ru/photos/d118cd3e-24d4-484b-874d-22dcecf582c5.jpg',
            'https://cdn.tripster.ru/photos/e1e6ebd2-9b0b-4e1e-a56d-49b4704883a8.jpg',
            'https://cdn.tripster.ru/photos/af631775-ad5a-43f1-95a6-30e2f8cf3fe1.jpg',
          ],
        },
      },
      {
        type: 'blank_line',
      },
      {
        type: 'vue',
        attrs: {
          component: 'experiences',
          ids: '14478',
        },
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: '',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'heading',
        attrs: {
          level: 2,
          id: 'headerh213',
        },
        style: 'atx',
        children: [
          {
            type: 'text',
            raw: 'Что попробовать',
          },
        ],
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: 'Ещё во время экскурсии мы заприметили смотровую площадку с красивым видом на ',
          },
          {
            type: 'link',
            children: [
              {
                type: 'text',
                raw: 'Городищенское озеро',
              },
            ],
            attrs: {
              url: 'https://experience.tripster.ru/experience/Izborsk/37847-gorodishenskoe-ozero/',
            },
          },
          {
            type: 'text',
            raw: '{:target="',
          },
          {
            type: 'text',
            raw: '_',
          },
          {
            type: 'text',
            raw: 'blank"} и белых лебедей и решили устроить на ней пикник, поэтому после прогулки отправились к магазинчикам за напитками и продуктами.',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: 'Тем временем город преобразился до неузнаваемости. Уютные улочки, пустовавшие ещё пару часов назад, наполнились путешественниками, которым не было конца и края. Пробравшись сквозь эту толпу, мы стали изучать ассортимент прилавков.',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: 'Сразу скажу — это было непросто, потому что выбор большой. Местные жители сами коптят рыбу, пекут хлеб, делают настойки и продают это прямо возле своих домов. Таких щедрых дегустаций, как тут, я не встречала нигде, так что имейте в виду — наесться и напиться можно не отходя от палаток.',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: 'Мы взяли для пикника леща, судака и снеток (озёрная рыба, которую солят, сушат и едят как снек). В трапезной на Печорской улице прихватили ещё тёплый батон из настоящей печи, а в одном из киосков — пиво и медовуху местного производства для создания праздничного настроения.',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'cap_image',
        attrs: {
          url: 'https://cdn.tripster.ru/photos/d3c4a9b0-f5f3-4d8a-976b-970d23f64802.jpg',
          caption: [
            {
              type: 'paragraph',
              children: [
                {
                  type: 'text',
                  raw: 'Блинная в Изборске. Фото автора',
                },
              ],
            },
          ],
          alt: 'Блинная в Изборске',
        },
      },
      {
        type: 'blank_line',
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: 'Если предпочитаете есть в кафе, в городе много мест, где можно подкрепиться. Больше всего посетителей мы встретили в уже упомянутой трапезной на Печорской улице, а также в блинной у Изборской крепости. И там и там подают ',
          },
          {
            type: 'link',
            children: [
              {
                type: 'text',
                raw: 'аутентичные блюда русской кухни',
              },
            ],
            attrs: {
              url: 'https://experience.tripster.ru/experience/Izborsk/6991-gastronomicheskie/',
            },
          },
          {
            type: 'text',
            raw: '{:target="',
          },
          {
            type: 'text',
            raw: '_',
          },
          {
            type: 'text',
            raw: 'blank"} (например, мясную похлёбку, пельмени ручной лепки и пирожки с ревенём) за скромные по меркам Москвы и Петербурга деньги.',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'heading',
        attrs: {
          level: 2,
          id: 'headerh214',
        },
        style: 'atx',
        children: [
          {
            type: 'text',
            raw: 'Что привезти с собой',
          },
        ],
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: 'Абсолютный лидер среди съедобных сувениров — изборский пряник. Тесто для него замешивают вручную и разливают по деревянным формам, а уже готовое изделие в виде зайчат, совят, рыбок и лошадок щедро посыпают сахарной пудрой. За счёт добавления имбиря у изборского пряника неповторимый вкус и аромат, который не спутать ни с чем другим.',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: 'Среди других местных специалитетов стоит обратить внимание на кипрейный мёд в виде нежнейшего суфле с лесными орехами (я брала с кедровыми — это объедение), чайные сборы из лечебных трав, сушёную и копчёную рыбу, ягодные настойки по семейным рецептам изборчан и сыры с фермы «Бебешкино» в Псковской области.',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'images',
        attrs: {
          caption: [
            {
              type: 'paragraph',
              children: [
                {
                  type: 'text',
                  raw: 'Изборские пряники. Фото автора',
                },
              ],
            },
          ],
          images: [
            'https://cdn.tripster.ru/photos/74837fb0-28c3-45de-862a-f1cb4298ebc1.jpg',
            'https://cdn.tripster.ru/photos/df61aed0-6912-4db6-a10b-eca12da62dd9.jpg',
          ],
        },
      },
      {
        type: 'blank_line',
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: 'Изборск также славится вязаными варежками с крупным и ярким орнаментом — например, разными вариациям ромба, листочками и розочками, снежинками и лебедями. Традиционные узоры заимствованы из русской культуры и ',
          },
          {
            type: 'link',
            children: [
              {
                type: 'text',
                raw: 'культуры сето',
              },
            ],
            attrs: {
              url: 'https://experience.tripster.ru/experience/Izborsk/72459-muzej-usadba-narodnosti-seto-v-sigovo/',
            },
          },
          {
            type: 'text',
            raw: '{:target="',
          },
          {
            type: 'text',
            raw: '_',
          },
          {
            type: 'text',
            raw: 'blank"} — коренного народа Псковской области.',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: 'В сувенирных лавках можно найти как недорогие магниты с изображением ',
          },
          {
            type: 'link',
            children: [
              {
                type: 'text',
                raw: 'Изборской крепости',
              },
            ],
            attrs: {
              url: 'https://experience.tripster.ru/experience/Pskov/21339-izborskaya-krepost/',
            },
          },
          {
            type: 'text',
            raw: '{:target="',
          },
          {
            type: 'text',
            raw: '_',
          },
          {
            type: 'text',
            raw: 'blank"}, так и эксклюзивные изделия местных мастеров. А ещё отсюда везут родниковую воду. Для этого в городском музее выпустили фирменную бутылку с надписью «Словенские ключи».',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'heading',
        attrs: {
          level: 2,
          id: 'headerh215',
        },
        style: 'atx',
        children: [
          {
            type: 'text',
            raw: 'Заключение',
          },
        ],
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: 'Изборск похож на шкатулку с секретом: невооружённым глазом его сокровища можно не увидеть и пройти мимо, так и не узнав о природных и культурных богатствах этого города. Совсем другое дело — гулять по уютным улочкам в компании ',
          },
          {
            type: 'link',
            children: [
              {
                type: 'text',
                raw: 'местного гида',
              },
            ],
            attrs: {
              url: 'https://experience.tripster.ru/experience/Pskov/9982-izborsk/',
            },
          },
          {
            type: 'text',
            raw: '{:target="',
          },
          {
            type: 'text',
            raw: '_',
          },
          {
            type: 'text',
            raw: 'blank"}, который знает, где кроются самые красивые и интересные локации, и с удовольствием делится своими знаниями.',
          },
        ],
      },
      {
        type: 'blank_line',
      },
      {
        type: 'vue',
        attrs: {
          component: 'experiences',
          city: 'Pskov',
          'general-tag': '642',
        },
      },
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            raw: '',
          },
        ],
      },
    ],
  },
] as Article[];

export const linkedArticles = [
  {
    id: 1715,
    type: 'article',
    slug: 'article_1715',
    title: 'Article 1715 title',
    subtitle: 'Article 1715 subtitle',
    img: 'https://cdn.tripster.ru/photos/71f609ed-46dd-4e55-8d23-e90caf17d291.jpg',
    reading_time: 800,
  },
  {
    id: 1784,
    type: 'article',
    slug: 'article_1784',
    title: 'Article 1784 title',
    subtitle: 'Article 1784 subtitle',
    img: 'https://cdn.tripster.ru/photos/09ca7772-90d1-4aa5-a22f-f33cfe59dd76.jpg',
    reading_time: 600,
  },
] as LinkedArticle[];
